export function breakLines(text) {
  var lines = text.split('<br/>');
  let html = '';
  lines.map(line => { // eslint-disable-line array-callback-return
    html += `<span class="mask"><span class="line">${line}</span></span>`;
  })
  return html;
}